import type { ComponentProps } from "react";
import type { Glyph } from "@edreamsodigeo/prisma-design-system";

export const tableCellsContent: {
  icon: ComponentProps<typeof Glyph>;
  type: string;
}[] = [
  {
    icon: {
      category: "Planes",
      name: "FlightDiagonal",
    },
    type: "one",
  },
  {
    icon: {
      category: "TravelProducts",
      name: "Hotel",
    },
    type: "two",
  },
  {
    icon: {
      category: "Transport",
      name: "Car",
    },
    type: "three",
  },
];
